import { CreateAppointmentRequest, TeamMemberType, V3AvailabilityType } from '../../../api';
import {
  AppointmentLength,
  AppointmentLengthType,
  Brand,
  BrandInteractionType,
  InteractionType,
} from '@lendi/core-constants';
import { Address } from '../../../pages/appointment-type';
import { AvailableAppointmentDate } from '../appointment-datetime';

export const createAppointmentRequestParams = (
  brand: Brand,
  selectedAvailableAppointment: AvailableAppointmentDate,
  appointmentType: InteractionType,
  timezone: string,
  customerId?: string,
  address?: Address,
  customerFirstName?: string,
  customerLastName?: string,
  storeId?: string,
  selfInteractionOverride?: boolean,
  isFromStorePage?: boolean,
  teamMemberType?: TeamMemberType,
  bookedBy?: string | null,
  bookedByRole?: 'Customer' | 'Team member'
) => {
  const appointmentLength = getAppointmentLength(
    brand,
    selfInteractionOverride ? InteractionType.Video : appointmentType
  );

  let params: CreateAppointmentRequest = {
    brokerSfIds: selectedAvailableAppointment.brokerIds,
    timeslot: {
      start: selectedAvailableAppointment.datetime.toISO(),
      end: selectedAvailableAppointment.datetime.plus({ minutes: appointmentLength }).toISO(),
    },
    customer: {
      id: customerId || '',
      timezone,
      firstName: customerFirstName,
      lastName: customerLastName,
    },
    interactionType: appointmentType,
    selfInteractionOverride,
    isFromStorePage,
    teamMemberType: teamMemberType ?? TeamMemberType.Broker,
    ...(bookedBy && { bookedBy }),
    ...(bookedByRole && { bookedByRole }),
  };

  //AQR-276 we need to have storeId as one of parameters to call SF to get brokers for phone/video/f2f/store interaction type when it is from store page
  if (
    (isFromStorePage &&
      (appointmentType === InteractionType.Video ||
        appointmentType === InteractionType.Phone ||
        appointmentType === InteractionType.FaceToFace)) ||
    appointmentType === InteractionType.Store
  ) {
    params = {
      ...params,
      storeId,
    };
  }

  if (appointmentType === InteractionType.FaceToFace) {
    params = {
      ...params,
      customer: {
        ...params.customer,
        address: {
          address: {
            unit: address!.unit,
            lotSection: address!.lotSection,
            level: address!.level,
            buildingName: address!.buildingName,
            streetNumber: address!.streetNumber,
            streetName: address!.streetName,
            streetType: address!.streetType,
            suburb: address!.suburb,
            postcode: address!.postcode,
            state: address!.state,
            country: address!.country,
          },
          formatString: address!.formatString,
        },
      },
    };
  }

  return params;
};

export const getAppointmentLength = (brand: Brand, appointmentType: InteractionType): number => {
  const appointmentLengthTypes = BrandInteractionType[brand];
  const appointmentLengthType = appointmentLengthTypes[appointmentType] as AppointmentLengthType;
  return AppointmentLength[appointmentLengthType]?.length;
};

export const checkAvailbilityByType = (
  interactionType: InteractionType,
  allAvailabilityTimes: Partial<V3AvailabilityType>
) => {
  return allAvailabilityTimes[interactionType]
    ? allAvailabilityTimes[interactionType]?.availability.length !== 0
    : false;
};
